import React, { useState, useEffect } from "react";
import { get } from 'lodash'
import {
  Grid,
  Button,
} from "@material-ui/core";
import { useForm, Controller } from "react-hook-form";
import { Box, Stack, Checkbox, Typography } from '@mui/material'
import { TextField } from "./form/TextField";
import { GalleryFormSectionHeading } from './GalleryFormSectionHeading'
import { getUserStoredCountry } from "v2_actions/auth_country";

export const GalleryHighLowResPriceFormFields = ({
  classes,
  control,
  field_name_prefix,
  optionalLowResPriceChecked,
  handleOptionalLowResPriceChange,
}) => {
  
  const currencyName = get(getUserStoredCountry(), 'currency_name')
  const labelStyling = {width: 180, fontWeight: 600, fontSize: 12, color: '#606060'}
  
  const renderPriceField = (fieldProps, disabled) => {
    return (
      <>
        &nbsp;&nbsp;
        <TextField
          disabled={disabled}
          type="text"
          variant="standard"
          fieldProps={fieldProps}
          className={classes.smallTextField}
          InputProps={{ disableUnderline: true }}
        />
      </>
    );
  };

  const renderCurrencyName = () => (
    <Typography sx={{width: 100, fontWeight: 600, fontSize: 12, color: '#606060'}}>
      {currencyName}
    </Typography>
  )

  return (
    <>
      <div>
        <GalleryFormSectionHeading
          heading='Pricing Details'
          subHeading='Set Prices:'
        />
        <Box ml={1} sx={{display: 'flex', height: 30, width: 370, alignItems: 'center'}}>
          <Typography sx={labelStyling}>
            Std Digital Price per Photo
          </Typography>
          <Checkbox
            checked
            disabled
            color="default"
            sx={{ paddingLeft:1 }}
          />
          <Controller
            name={`${field_name_prefix}.base_price`}
            control={control}
            render={(fieldProps) => renderPriceField(fieldProps, false)}
          />
          {renderCurrencyName()}
        </Box>
        <Box ml={1} sx={{display: 'flex', height: 30, width: 370, alignItems: 'center'}}>
          <Typography sx={labelStyling}>
            Optional Low Res Price
          </Typography>
          <Checkbox
            color="default"
            sx={{ paddingLeft:1 }}
            checked={optionalLowResPriceChecked}
            onChange={handleOptionalLowResPriceChange}
          />
          <Controller
            name={`${field_name_prefix}.low_res_price`}
            control={control}
            render={(fieldProps) => renderPriceField(fieldProps, !optionalLowResPriceChecked)}
          />
          {renderCurrencyName()}
        </Box>
      </div>
    </>
  );
};
